/* tslint:disable */
/* eslint-disable */

/**
 * 0 = NC
 * 1 = OK
 * 2 = NOK
 */
export enum FicheControleTypeStatut {
  NC = 0,
  OK = 1,
  NOK = 2
}
